import React, {createContext, useContext} from 'react'

export interface UIContextProps {
    language: string
    isUserOnDiscord: boolean
    isUserOnMobileAppOrWeb: boolean
    isUserOnMobile: boolean
    isUserOnMobileWebBrowser: boolean
    isUserOnTabletApp: boolean
    isUserOnDiscordMobile: boolean
    discordActivityMobileOrientation: string
    isPortraitMode: boolean
    versionNumber: number
    discordUrl: string
    playersOnline: number
    gamesToday: number
}

const UIContext = createContext<UIContextProps | undefined>(undefined)

const defaultUIContextValues: UIContextProps = {
    language: 'en',
    isUserOnDiscord: false,
    isUserOnMobileAppOrWeb: false,
    isUserOnMobile: false,
    isUserOnMobileWebBrowser: false,
    isUserOnTabletApp: false,
    isUserOnDiscordMobile: false,
    discordActivityMobileOrientation: '',
    isPortraitMode: false,
    versionNumber: 123,
    discordUrl: 'https://discord.gg/colonist',
    playersOnline: 12345,
    gamesToday: 54321,
}

export const useUIGlobalContext = () => {
    const context = useContext(UIContext)
    if(!context) throw new Error('UIGlobalContext not found')
    return context
}

type DefaultUIContextProviderProps = React.PropsWithChildren<Partial<UIContextProps>>

export const DefaultUIContextProvider = ({children, ...overrides}: DefaultUIContextProviderProps) => (
    <UIContext.Provider value={{...defaultUIContextValues, ...overrides}}>
        {children}
    </UIContext.Provider>
)
